export const customModal = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0',
    zIndex:5000,
    borderRadius: '20px',
    boxShadow: '6px 6px 10px rgba(128,128,128, 0.7)',
    backgroundColor: '#f9f9f9',
  },
}
